import { Component, Input, ViewChild } from "@angular/core";
import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

// interfaces
import { IUser } from "src/app/models/Identity/user";
import {
  ICourseSession,
  IGetQrSessionsParams,
} from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { AuthenticationService } from "src/app/auth/services/authentication.service";

@Component({
  selector: "app-share-qrs-catalog",
  templateUrl: "./share-qrs-catalog.component.html",
  styleUrls: ["./share-qrs-catalog.component.css"],
})
export class ShareQrsCatalogComponent {
  @Input()
  sessions: ICourseSession[] = [];

  @ViewChild("modal")
  public qrModal!: GeneralEmptyModalComponent;
  public userLogged: IUser | null = null;
  private modalBasicTitle: string = "QR de la sesión";

  // Table
  protected isLoadingTableData: boolean = false;
  protected errorOccurred: boolean = false;
  // Filter Dates
  public startDate: NgbDate | null = null;
  public endDate: NgbDate | null = null;
  // filters
  public textSearch: string = "";
  // pagination
  page: number = 1;
  pageSize: number = 1000;
  collectionSize: number = 0;
  // data
  public isMyQRModel: boolean = true;
  public selectedSesion: ICourseSession | null = null;
  public userList: IUser[] | null = null;

  constructor(private _authInternal: AuthenticationService) {}

  public modalConfig: ModalConfig = {
    modalTitle: this.modalBasicTitle,
    hideDismissButton: true,
    hideCloseButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };

  async openModal(selectedSession: ICourseSession) {
    this.modalConfig.modalTitle = `${selectedSession.titulo} - ID Localizador: ${selectedSession.IdLocalizador}`;
    this.selectedSesion = selectedSession;
    await this.qrModal.open();
  }

  async closeModal() {
    this.selectedSesion = null;
    await this.qrModal.close();
  }

  get getFilterAndPaginationParams(): IGetQrSessionsParams {
    return {
      pageNumber: this.page,
      pageSize: this.pageSize,
      textSearch: this.textSearch,
    };
  }
}
